import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../src/environments/environment";
import Swal from "sweetalert2";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class ApiService {
  baseUrl: any = "";
  mediaURL: any = "";
  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseURL;
    this.mediaURL = environment.mediaURL;
  }

  alerts(position:any, icon:any, title:any) {
    Swal.fire({
      position: position ?? "top-end",
      icon: icon ?? "success",
      title: title ?? "Your work has been saved",
      showConfirmButton: false,
      timer: 1500,
    });
    // Swal.fire(
    //   title,
    //   message,
    //   type
    // );
  }

  uploadFile(url:any, param:any, files: File[]) {
    const formData = new FormData();
    Array.from(files).forEach((f) => formData.append("file[]", f));
    formData.append("param", JSON.stringify(param))
    console.log('property input: ', JSON.stringify(param))
    return this.http.post(this.baseUrl + url, formData);
  }
  // Returns an observable
  uploadService(url:any, file:any): Observable<any> {
    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', file, file.name);

    // Make http post request over api
    // with formData as req
    return this.http.post(this.baseUrl + url, formData);
  }

  getCurrencyCode() {
    return environment.general.code;
  }

  getCurrecySymbol() {
    return environment.general.symbol;
  }

  sendNotification(msg:string, title:string, id:number) {
    const body = {
      app_id: environment.onesignal.appId,
      include_player_ids: [id],
      headings: { en: title },
      contents: { en: msg },
      data: { task: msg },
    };
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", `Basic ${environment.onesignal.restKey}`),
    };
    return this.http.post(
      "https://onesignal.com/api/v1/notifications",
      body,
      header
    );
  }

  JSON_to_URLEncoded(element:any, key?:any, list?:any) {
    let new_list = list || [];
    if (typeof element === "object") {
      for (let idx in element) {
        this.JSON_to_URLEncoded(
          element[idx],
          key ? key + "[" + idx + "]" : idx,
          new_list
        );
      }
    } else {
      new_list.push(key + "=" + encodeURIComponent(element));
    }
    return new_list.join("&");
  }

  postService(url: any, body: any) {
    const param = this.JSON_to_URLEncoded(body);
    console.log(param);
    return this.http.post(this.baseUrl + url, body);
  }

  post(url: any, body: any) {
    var token = window.sessionStorage.getItem('auth-token')
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Authorization", "Bearer " + `${token}`),
    };
    const param = this.JSON_to_URLEncoded(body);
    console.log(param);
    return this.http.post(this.baseUrl + "enterprise/brendydata/" + url, JSON.stringify(body), header);
  }

  postBuy(url: any, body: any) {
    var token = window.sessionStorage.getItem('auth-token')
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", "Bearer " + `${token}`),
    };
    const param = this.JSON_to_URLEncoded(body);
    console.log(param);
    return this.http.post("https://firstdevlab.com/api/v1/enterprise.php?mk_client=brendydata&type=" + url, param, header);
  }

  get(url: any) {
    const header = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
    };
    return this.http.get(this.baseUrl + url, header);
  }

  externalGet(url: any) {
    var token = window.sessionStorage.getItem('auth-token')
    const header = {
      headers: new HttpHeaders()
        .set("Authorization", "Bearer " + `${token}`),
    };
    return this.http.get(this.baseUrl + "enterprise/brendydata/"+ url, header);
  }

  externalGet2(url: any) {
    return this.http.get(this.baseUrl + "client/brendydata/"+ url);
  }
}
